import React, { useEffect } from "react";
import "./QuranWithTajweed.css";
import CourseCard from "../../../Components/AllCourseCard/CourseCard";
import PricingCards from "../../Home/PricingCards";
import CourseFeatures from "../../../Components/CourseFeatures/CourseFeatures";
const QuranwithTajweed = () => {
  useEffect(() => {
    document.title = "Quran with Tajweed";
  }, []);
  return (
    <>
      <div className="container-fluid bg-img-5 text-center">
        <h1 className="main-1-heading"> Quran with Tajweed </h1>
      </div>

      <div className="container main-data mt-5 ">
        <h1 className="main-data-hrading">Online Quran Tajweed Course</h1>
        <p className="main-data-para">
          Quranic Tajweed is the set of rules for reading and pronouncing Quran.
          It sees to it that every letter is pronounced accurately with the
          right accent and pacing. Tajweed is beneficial in keeping the
          tradition of Quran as was revealed and pronounced by RasoolAllah
          (S.W.A) alive. This involves mastering many aspects such as the proper
          pronunciation of letters (makhraj), characteristics of letters,
          observance to rules regarding elongation, stopping and merging. By
          following these instructions, the reciters can gain a better
          understanding of their Recitatoin and thus improve its beauty in long
          terms as well give heed to spirtual upliftment.
        </p>
        <p className="main-data-para">
          As with proper pronunciation of the Arabic script, learning to recite
          Quran properly is an essential skill for anyone wanting a more
          meaningful relationship between them and The Glorious Quraan. We also
          focus on Tajweed in our academy so each letter pronounced perfectly as
          it should be pronounce, all the worlds combined with out any error.
          Correcting our Tajweed is not just for pronunciation and melody when
          reciting, it preserves the meaning of Quran. To help students with the
          complexities of pronunciation, enunciation and rhythm for them to
          recite Qur'an proudly. From beginners to those in need of
          "brushing-up," our Tajweed program provides the tools and
          understanding you need for a superior recitation.
        </p>
      </div>
      <div className="container">
        <h1 className="card-title text-center h1-heading">
          In the Quran Tajweed course, you’ll learn:
        </h1>
        <div className="row">
          <div className="col-sm-12 col-lg-6">
            <div className="card-noorani">
              <ul className="card-content ms-4">
                <li className="lists">Quran recitation with proper accent</li>
                <li className="lists">Rules about recitation</li>
                <li className="lists">Exercises of Arabic alphabets</li>
                <li className="lists">Recitation with Hadar and Tarteel</li>
                <li className="lists">letter changes its form in the Quran</li>
                <li className="lists">Long harakat should be stretched</li>
              </ul>
            </div>
          </div>
          <div className="col-sm-12 col-lg-6">
            <ul className="card-content ms-4">
              <li className="lists">Rules of Izhar, Ikhfa, Idgham and Iqlab</li>
              <li className="lists">
                Rules of Izhar-e-shafawi, Ikhfa-e-shafawi, Idgham-e-shafawi
              </li>
              <li className="lists">Exercises with the rules of Tajweed</li>
              <li className="lists">The Shaddah</li>
              <li className="lists">Hamzatul-Wassl</li>
            </ul>
          </div>
        </div>
      </div>

      <CourseFeatures />

      <CourseCard />
      <PricingCards />
    </>
  );
};

export default QuranwithTajweed;
